import type { ScoutingCriterionDefinition } from 'domain/feature/hub/company/scouting/api/scoutingService'
import { formatScoutingCriteriaForDisplay } from 'domain/feature/hub/company/scouting/scoutingSelection/formatScoutingCriteriaDisplay'
import type { IResolverOpportunity } from './contracts'
import { formatCompanySizeForDisplay } from './behavior'

export type OpportunityCriteriaInput = Pick<
  IResolverOpportunity,
  'scouting' | 'segment' | 'category' | 'businessModel' | 'companySize'
>

export const formatOpportunityCriteriaText = (
  opportunity: OpportunityCriteriaInput,
  criteriaDefinitions: ScoutingCriterionDefinition[] | undefined
): string => {
  const fromScouting = formatScoutingCriteriaForDisplay(
    opportunity.scouting?.[0]?.criteria,
    criteriaDefinitions
  )
  if (fromScouting) return fromScouting
  const company = formatCompanySizeForDisplay(opportunity.companySize)
  return [opportunity.segment, opportunity.category, opportunity.businessModel, company]
    .filter(Boolean)
    .join(' | ')
}
